module.exports = __webpack_public_path__ + "img/map.1e687538.png";